import React from 'react';
import withStyles from "../wrappers/withStyles";

function More({ color }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="mt-1">
      <g fill="none" fillRule="evenodd" stroke={color} strokeWidth="4">
        <circle cx="18" cy="50" r="10" />
        <circle cx="50" cy="50" r="10" />
        <circle cx="82" cy="50" r="10" />
      </g>
    </svg>
  );
}

More.defaultProps = {
  color: 'white',
};

export default withStyles(More);
